// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center_center div p[data-v-76376618]:first-child{color:#686868}.center_center div p[data-v-76376618]:last-child{color:#ff3c32}", ""]);
// Exports
module.exports = exports;
